export default "__VITE_ASSET__BU$_EI$e__"